<script>
</script>

<div>
	<div class="title">
		Character classes
	</div>
	<table>
		<tr>
			<td>.</td>
			<td>any character</td>
		</tr>
		<tr>
			<td>\d</td>
			<td>any digit</td>
		</tr>
		<tr>
			<td>\s</td>
			<td>any white space character</td>
		</tr>
		<tr>
			<td>\</td>
			<td>escape</td>
		</tr>
	</table>
	<div class="title">
		Assertions
	</div>
	<table>
		<tr>
			<td>^</td>
			<td>beginning of input</td>
		</tr>
		<tr>
			<td>$</td>
			<td>end of input</td>
		</tr>
	</table>
	<div class="title">
		Groups and ranges
	</div>
	<table>
		<tr>
			<td>x|y</td>
			<td>either "x" or "y"</td>
		</tr>
		<tr>
			<td>[xyz]<br>[a-c]</td>
			<td>any one of the enclosed characters</td>
		</tr>
		<tr>
			<td>[^xyz]<br>[^a-c]</td>
			<td>anything that is not enclosed in the brackets</td>
		</tr>
	</table>
	<div class="title">
		Quantifiers
	</div>
	<table>
		<tr>
			<td>x*</td>
			<td>"x" 0 or more times</td>
		</tr>
		<tr>
			<td>x+</td>
			<td>"x" 1 or more times</td>
		</tr>
		<tr>
			<td>x?</td>
			<td>"x" 0 or 1 times</td>
		</tr>
		<tr>
			<td>x&#123;n&#125;</td>
			<td>exactly "n" occurrences of "x"</td>
		</tr>
		<tr>
			<td>x&#123;n,&#125;</td>
			<td>at least "n" occurrences of "x"</td>
		</tr>
		<tr>
			<td>x&#123;n,m&#125;</td>
			<td>at least "n" and at most "m" occurrences of "x"</td>
		</tr>
		<tr>
			<td>x+?</td>
			<td>"non-greedy"</td>
		</tr>
	</table>

</div>

<style>
	.title {
		font-weight: bold;
		margin-top: 5px;
		margin-bottom: 5px;
		text-align: left;
	}

	table {
		width: 100%;
	}

	td {
		padding-bottom: 10px;
	}

	td:nth-of-type(2n+1) {
		font-family: var(--font-family-mono);
	}

	td:nth-of-type(2n) {
		text-align: left;
		padding-left: 10px;
	}
</style>